/** FIDS flight type badge colors (A/D column). */
export const FLIGHT_TYPE_COLORS = {
  arrival: '#00897B',
  departure: '#1565C0'
};

/** FIDS status badge colors (background + border hex). */
export const STATUS_COLORS = {
  proposed: '#7986CB',
  scheduled: '#1976D2',
  expected: '#42A5F5',
  outgate: '#5E35B1',
  inair: '#00ACC1',
  ingate: '#26A69A',
  landed: '#2E7D32',
  delayed: '#FB8C00',
  notakeoffinfo: '#FB8C00',
  cancelled: '#E53935',
  unknown: '#78909C',
  pastflight: '#BDBDBD'
};

const DEFAULT_STATUS_KEY = 'unknown';

/** Operator / API aliases without a dedicated color. */
const STATUS_ALIASES = {
  boarding: 'outgate',
  finalcall: 'delayed',
  lastcall: 'delayed',
  gatesclosed: 'unknown',
  gateclosed: 'unknown',
  closed: 'unknown',
  canceled: 'cancelled'
};

const KNOWN_KEYS = new Set(Object.keys(STATUS_COLORS));

/**
 * Normalizes raw flight status keys/labels for color lookup.
 */
export function normalizeStatusKey(raw) {
  if (raw == null || raw === '') return '';
  const compact = String(raw).toLowerCase().replace(/[\s_-]+/g, '');
  if (!compact) return '';

  if (STATUS_ALIASES[compact]) return STATUS_ALIASES[compact];
  if (KNOWN_KEYS.has(compact)) return compact;
  return DEFAULT_STATUS_KEY;
}

function statusTextColor(key) {
  return key === 'pastflight' ? '#212121' : '#ffffff';
}

function badgeStyleFromColor(color, textColor = '#ffffff') {
  return {
    backgroundColor: color,
    color: textColor,
    border: `1px solid ${color}`
  };
}

/**
 * Inline styles for arrival/departure type badge (A/D).
 */
export function getFlightTypeBadgeStyle(flightType) {
  const ft = flightType ? String(flightType).toLowerCase() : '';
  if (!ft) {
    return badgeStyleFromColor(STATUS_COLORS.unknown);
  }
  if (ft.startsWith('a') || ft.includes('arr')) {
    return badgeStyleFromColor(FLIGHT_TYPE_COLORS.arrival);
  }
  if (ft.startsWith('d') || ft.includes('dep')) {
    return badgeStyleFromColor(FLIGHT_TYPE_COLORS.departure);
  }
  return badgeStyleFromColor(STATUS_COLORS.unknown);
}

/**
 * Inline styles for a status badge from the canonical color set.
 */
export function getStatusBadgeStyle(raw) {
  const key = normalizeStatusKey(raw) || DEFAULT_STATUS_KEY;
  const backgroundColor = STATUS_COLORS[key] || STATUS_COLORS[DEFAULT_STATUS_KEY];
  return badgeStyleFromColor(backgroundColor, statusTextColor(key));
}

/**
 * @deprecated Use getStatusBadgeStyle for per-status hex colors.
 */
export function getStatusBadgeClass(raw) {
  const key = normalizeStatusKey(raw);
  if (!key) return 'status-badge--default';
  return `status-badge--${key}`;
}
